import { ExperienceDate } from "../pages/teamExperiences/models/ExperienceSummaryModel";

// UAT-319: money is expressed as "USD 1,000" — no $ icon, no cents,
// with thousands separators. Centralised so all surfaces stay in sync.
export function formatUsdAmount(amount: number | string | null | undefined): string {
  if (amount == null || amount === '') return '';
  const num = typeof amount === 'string' ? Number(amount) : amount;
  if (!Number.isFinite(num)) return '';
  const rounded = Math.round(num);
  return `USD ${rounded.toLocaleString('en-US')}`;
}

export const getMaxBirthdayDate = (): string => {
    const maxDate = new Date()
    maxDate.setFullYear(maxDate.getFullYear() - 18)
    return maxDate.toISOString().split('T')[0]
}

export function getTimeDifference(range: ExperienceDate): string {
  const startDate = new Date(range.start);
  const endDate = new Date(range.end);

  const diffMs = endDate.getTime() - startDate.getTime();

  if (diffMs < 0) {
    throw new Error("The end date is earlier than the start date.");
  }

  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));

  if (diffHours >= 24) {
    const diffDays = Math.floor(diffHours / 24);
    return `${diffDays} ${diffDays === 1 ? "Day" : "Days"}`;
  } else {
    return `${diffHours} ${diffHours === 1 ? "Hour" : "Hours"}`;
  }
}

// UAT-149: catalog duration names are stored plural (Weeks, Days, Hours, Months);
// when the amount is 1, drop the trailing "s" so we render "1 Week" instead of
// "1 Weeks"/"1 WeekS".
export function formatDurationLabel(amount: number | undefined | null, unitName: string): string {
  if (amount == null || amount === 0) return '';
  const safeUnit = (unitName || '').trim();
  if (!safeUnit) return `${amount}`;
  const singular = amount === 1 && /s$/i.test(safeUnit) ? safeUnit.slice(0, -1) : safeUnit;
  return `${amount} ${singular}`;
}

export function pickDurationName(
  durations: { id: number | string; name: string }[] | null | undefined,
  durationTypeId: number | string | null | undefined,
): string {
  if (!durations || durationTypeId == null) return '';
  const match = durations.find(
    (d) =>
      d.id == durationTypeId ||
      d.name?.toLowerCase() === String(durationTypeId).toLowerCase() ||
      `${d.name?.toLowerCase()}s` === String(durationTypeId).toLowerCase()
  );
  if (match) return match.name;
  if (typeof durationTypeId === 'string' && isNaN(Number(durationTypeId))) {
    return durationTypeId.charAt(0).toUpperCase() + durationTypeId.slice(1);
  }
  return '';
}